export interface CareersReport {
  Report_Entry: JobData[];
}

export interface GroupedJobsData {
  title: string;
  jobs: JobData[];
}

export interface JobData {
  Cost_Center_Hierarchy: string;
  jobFamilyGroup: string;
  Cost_Center: string;
  timeType: string;
  All_Locations: Location[];
  workerSubType: string;
  jobRequisitionId: string;
  title: string;
  url: string;
  primaryLocation: string;
  jobFamily: string;
  jobDescription: string;
  External_Apply_URL: string;
  startDate: string;
}

export interface Location {
  country: string;
  locationName: string;
  city: string;
  'Primary_Address_-_Postal_Code': string;
  state: string;
}

export const groupJobsByJobFamilyGroup = (jobs: JobData[]): GroupedJobsData[] => {
  const groupedJobsMap = new Map<string, { title: string; jobs: JobData[] }>();

  for (const job of jobs) {
    if (!groupedJobsMap.has(job.jobFamilyGroup)) {
      groupedJobsMap.set(job.jobFamilyGroup, {
        title: job.jobFamilyGroup,
        jobs: [job],
      });
    } else {
      groupedJobsMap.get(job.jobFamilyGroup)?.jobs.push(job);
    }
  }

  const groupedJobs = [...groupedJobsMap.values()];

  return groupedJobs;
};
